import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedDataReceivedSelector, setSelectedDataReceived } from '../filtersSlice';
import { SelectedDataReceivedStatusType } from '../utils';

export const useSelectedDataReceived = () => {
  const dispatch = useDispatch();
  const dataReceived = useSelector(selectedDataReceivedSelector);

  const onSelectDataReceived = React.useCallback((selected: SelectedDataReceivedStatusType) => {
    dispatch(setSelectedDataReceived(selected));
  }, [dispatch]);

  return {
    dataReceived,
    onSelectDataReceived,
  };
};
